'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _preludeExtension = require('prelude-extension');

var _unidecode = require('unidecode');

var _unidecode2 = _interopRequireDefault(_unidecode);

var _tags = require('redux/modules/tags');

var tagActions = _interopRequireWildcard(_tags);

var _Creatable = require('react-select/lib/Creatable');

var _Creatable2 = _interopRequireDefault(_Creatable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagBox = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, tagActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TagBox, _Component);

  function TagBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TagBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TagBox.__proto__ || (0, _getPrototypeOf2.default)(TagBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ajax: null,
      items: [],
      loaded: false,
      loading: false,
      selectedItems: _this.props.selectedTags.map(function (type) {
        return {
          value: type.id,
          label: type.name
        };
      }),
      selectedTags: _this.props.selectedTags
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TagBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedTags !== this.props.selectedTags) {
        this.setState({
          selectedTags: nextProps.selectedTags,
          selectedItems: nextProps.selectedTags.map(function (tag) {
            return {
              value: tag.id,
              label: tag.name
            };
          })
        });
      }
    }
  }, {
    key: 'onSearchChange',
    value: function onSearchChange(input) {
      var _this2 = this;

      var query = input.trim();
      var ajax = this.state.ajax;


      if (ajax) {
        clearTimeout(ajax);
      }

      this.setState({
        loaded: false,
        ajax: setTimeout(function () {
          _this2.loadTags(query);
        }, 250)
      });
    }
  }, {
    key: 'onValuesChange',
    value: function onValuesChange(values) {
      var _this3 = this;

      this.setState({
        selectedItems: values
      }, function () {
        var onChange = _this3.props.onChange;

        var tags = _this3.getTagFromValues(_this3.state.selectedItems);
        onChange(tags);
      });
    }
  }, {
    key: 'getTagFromValues',
    value: function getTagFromValues(values) {
      return values.map(function (item) {
        if (item.value === item.label) {
          return { name: item.label };
        }
        return { id: item.value, name: item.label };
      });
    }
  }, {
    key: 'loadTags',
    value: function loadTags(query) {
      var _this4 = this;

      if (query.length > 2) {
        this.setState({
          ajax: null,
          loading: true
        }, function () {
          _this4.props.search(query).then(function (tags) {
            var typesRendered = tags.result.data.map(function (tag) {
              return {
                value: tag.id,
                label: tag.name,
                labelPartitions: (0, _preludeExtension.partitionString)((0, _unidecode2.default)(tag.name).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase())
              };
            });
            _this4.setState({
              items: typesRendered,
              loading: false,
              loaded: !_this4.state.ajax
            });
          });
        });
      } else if (query.length <= 2) {
        this.setState({
          items: []
        });
      } else {
        this.state.items.map(function (type) {
          type.labelPartitions = (0, _preludeExtension.partitionString)((0, _unidecode2.default)(type.label).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase());
        });
      }
    }
  }, {
    key: 'filterOptions',
    value: function filterOptions(options, values, query) {
      return options.filter(function (option) {
        var inValues = values.filter(function (value) {
          return option.value === value.value;
        });
        var label = (0, _unidecode2.default)(option.label).toLowerCase().trim();
        var queryTyped = (0, _unidecode2.default)(query).toLowerCase().trim();
        return !inValues.length && label.indexOf(queryTyped) > -1;
      });
    }
  }, {
    key: 'handleExitPopover',
    value: function handleExitPopover() {
      var onChange = this.props.onChange;

      var tags = this.getTagFromValues(this.state.selectedItems);
      onChange(tags);
    }
  }, {
    key: 'isValidNewOption',
    value: function isValidNewOption(input, _, selectOptions) {
      if (input.length < 3) {
        return false;
      }

      if (!this.state.loaded) {
        return false;
      }

      if (selectOptions.find(function (o) {
        return o.label === input;
      })) {
        return false;
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          errors = _props.errors,
          polyglot = _props.polyglot,
          popoverContainer = _props.popoverContainer,
          required = _props.required;
      var _state = this.state,
          selectedTags = _state.selectedTags,
          loading = _state.loading;


      var boxUI = '';
      if (selectedTags.length <= 0) {
        // Empty
        boxUI = _react2.default.createElement(TagBox.Empty, { polyglot: polyglot, errors: errors, required: required });
      } else {
        // HasTags
        boxUI = _react2.default.createElement(TagBox.HasTags, { polyglot: polyglot, tags: selectedTags, errors: errors });
      }

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'tagBoxOverlayTrigger',
          trigger: 'click',
          placement: 'top',
          rootClose: true,
          container: popoverContainer,
          onExit: this.handleExitPopover.bind(this),
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'tagBoxPopover', className: 'tag-box-popover' },
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'activity-search' },
                polyglot.t('events.tagBox.add')
              ),
              _react2.default.createElement(_Creatable2.default, {
                isMulti: true,
                autoFocus: true,
                className: 'react-select',
                classNamePrefix: 'react-select',
                options: this.state.items,
                value: this.state.selectedItems,
                onInputChange: this.onSearchChange.bind(this),
                onChange: this.onValuesChange.bind(this),
                isLoading: loading,
                allowCreateWhileLoading: false,
                formatCreateLabel: function formatCreateLabel(label) {
                  return polyglot.t('events.tagBox.createTag') + ' ' + label + '\u2026';
                },
                placeholder: polyglot.t('events.tagBox.select'),
                loadingMessage: function loadingMessage() {
                  return polyglot.t('events.loading');
                },
                isValidNewOption: this.isValidNewOption.bind(this),
                noOptionsMessage: function noOptionsMessage(search) {
                  var query = search.inputValue.trim();
                  var values = _this5.state.selectedItems;

                  var noResultsText = '';
                  if (_this5.state.loading) {
                    noResultsText = polyglot.t('events.loading');
                  } else if (values.map(function (value) {
                    return value.label;
                  }).indexOf(query) !== -1) {
                    noResultsText = polyglot.t('events.tagBox.tagAlreadyExists');
                  } else if (query.length < 3) {
                    noResultsText = polyglot.t('events.tagBox.typeSome');
                  } else {
                    noResultsText = polyglot.t('events.tagBox.noResults');
                  }

                  return _react2.default.createElement(
                    'div',
                    { className: 'no-results-found' },
                    noResultsText
                  );
                }
              }),
              _react2.default.createElement(
                'p',
                { className: 'help-block' },
                polyglot.t('events.tagBox.help')
              )
            )
          )
        },
        boxUI
      );
    }
  }], [{
    key: 'Empty',
    value: function Empty(_ref2) {
      var errors = _ref2.errors,
          onClick = _ref2.onClick,
          polyglot = _ref2.polyglot,
          required = _ref2.required;

      return _react2.default.createElement(
        'div',
        { className: 'tag-box empty dashed-box' + (errors.length > 0 ? ' has-error' : ''), onClick: onClick },
        _react2.default.createElement('span', { className: 'icon-cg-tag left-icon' }),
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('events.tagBox.title')
        ),
        required && _react2.default.createElement(
          'span',
          { className: 'label label-danger label-required' },
          'Requis'
        )
      );
    }
  }, {
    key: 'HasTags',
    value: function HasTags(_ref3) {
      var onClick = _ref3.onClick,
          tags = _ref3.tags,
          errors = _ref3.errors;

      return _react2.default.createElement(
        'div',
        { className: 'tag-box has-tags line-box event-content-box' + (errors.length > 0 ? ' has-error' : ''), onClick: onClick },
        _react2.default.createElement(TagBox.SelectedTags, { tags: tags })
      );
    }
  }, {
    key: 'SelectedTags',
    value: function SelectedTags(_ref4) {
      var tags = _ref4.tags;

      var tagsUI = tags.map(function (tag, index) {
        return _react2.default.createElement(
          'span',
          { key: index, className: 'label label-default' },
          tag.name
        );
      });
      return _react2.default.createElement(
        'span',
        null,
        tagsUI
      );
    }
  }]);
  return TagBox;
}(_react.Component), _class2.propTypes = {
  errors: _propTypes2.default.array.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  onChange: _propTypes2.default.func,
  selectedTags: _propTypes2.default.array,
  search: _propTypes2.default.func.isRequired,
  required: _propTypes2.default.bool
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = TagBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/TagBox.js
// module id = 2222
// module chunks = 0